<script>
	import { isPortraitScreen } from '../js/model/stores';
	import { onMount } from 'svelte';

	let portrait;

	export let speed = 4;
	export let top = 0;
	export let bottom = 0;

	onMount(() => {
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	});

</script>

<style>
	svg {
		margin-left: -5%;
		width: 110vw;
		height: auto;
		animation: topwave 4s infinite linear;
		position: absolute;
		left: 0;
		z-index: 20;
	}

	svg.portrait {
		height: 3vh;
		width: auto;
	}

	/**
	 * We set the animation name based on the top/bottom specification.
	 * Adding the prefix "-global-" prevents Svelte from appending the typical random hash to selectors.
	 */
	@keyframes -global-topwave {
		from {
			transform: translateX(-2.5%) translateY(-50%)
		}
		to {
			transform: translateX(2.5%) translateY(-50%)
		}
	}

	@keyframes -global-bottomwave {
		from {
			transform: translateX(-2.5%) translateY(50%)
		}
		to {
			transform: translateX(2.5%) translateY(50%)
		}
	}
</style>

<svg class:portrait class="wave" style="animation-name: {top ? 'topwave' : 'bottomwave'}; animation-duration: {speed};{top? `top: ${top};` : ''}{bottom? `bottom: ${bottom};` : ''}" width="1440" height="31" viewBox="0 0 1440 31" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M73.8991 31L37.1264 3.52273L1.76792 30.2955L0 28.1818L37.1264 0L73.8991 27.4773L110.318 0L145.323 26.4205L180.682 0L217.101 27.4773L253.52 0L291 28.1818L289.232 30.2955L253.52 3.17045L217.101 30.6477L180.682 3.17045L145.323 29.9432L110.318 3.52273L73.8991 31Z" fill="#5A97C3"/>
	<path d="M360.899 31L324.126 3.52273L288.768 30.2955L287 28.1818L324.126 0L360.899 27.4773L397.318 0L432.323 26.4205L467.682 0L504.101 27.4773L540.52 0L578 28.1818L576.232 30.2955L540.52 3.17045L504.101 30.6477L467.682 3.17045L432.323 29.9432L397.318 3.52273L360.899 31Z" fill="#5A97C3"/>
	<path d="M648.645 31L611.999 3.52273L576.762 30.2955L575 28.1818L611.999 0L648.645 27.4773L684.939 0L719.824 26.4205L755.061 0L791.355 27.4773L827.649 0L865 28.1818L863.238 30.2955L827.649 3.17045L791.355 30.6477L755.061 3.17045L719.824 29.9432L684.939 3.52273L648.645 31Z" fill="#5A97C3"/>
	<path d="M935.899 31L899.126 3.52273L863.768 30.2955L862 28.1818L899.126 0L935.899 27.4773L972.318 0L1007.32 26.4205L1042.68 0L1079.1 27.4773L1115.52 0L1153 28.1818L1151.23 30.2955L1115.52 3.17045L1079.1 30.6477L1042.68 3.17045L1007.32 29.9432L972.318 3.52273L935.899 31Z" fill="#5A97C3"/>
	<path d="M1222.9 31L1186.13 3.52273L1150.77 30.2955L1149 28.1818L1186.13 0L1222.9 27.4773L1259.32 0L1294.32 26.4205L1329.68 0L1366.1 27.4773L1402.52 0L1440 28.1818L1438.23 30.2955L1402.52 3.17045L1366.1 30.6477L1329.68 3.17045L1294.32 29.9432L1259.32 3.52273L1222.9 31Z" fill="#5A97C3"/>
</svg>
